const pillars = [
  {
    icon: 'ri-chat-check-fill',
    title: 'Clear Communication',
    desc: 'You\'ll always know what we\'re doing, why we\'re doing it, and what it costs. No surprises.',
  },
  {
    icon: 'ri-brush-fill',
    title: 'Tidy Workmanship',
    desc: 'We treat your home with respect — clean work areas, neat cable runs, and a spotless finish every time.',
  },
  {
    icon: 'ri-thumb-up-fill',
    title: 'Honest Recommendations',
    desc: 'We recommend only what\'s needed. No upsells, no scare tactics — just honest professional guidance.',
  },
  {
    icon: 'ri-calendar-check-fill',
    title: 'Respect for Your Schedule',
    desc: 'We show up on time, finish efficiently, and keep you informed of every change to the timeline.',
  },
  {
    icon: 'ri-shield-check-fill',
    title: 'Code-Compliant & Safe',
    desc: 'Every installation meets or exceeds NEC standards. Your family\'s safety is never negotiated.',
  },
];

const WhyChooseUs = () => (
  <section id="why-us" className="relative bg-white py-28 overflow-hidden">
    {/* Subtle copper accent top-left */}
    <div className="absolute -top-40 -left-40 w-96 h-96 rounded-full bg-gradient-to-br from-[#D97706]/6 to-transparent pointer-events-none" />

    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-20">
        {/* Left — Image */}
        <div className="w-full lg:w-[45%] relative flex-shrink-0 scroll-reveal scroll-from-left">
          <div className="relative rounded-3xl overflow-hidden shadow-[0_24px_80px_rgba(10,22,40,0.18)]">
            <img
              src="https://public.readdy.ai/ai/img_res/7ac237467123d378cd3f98bfa6c1104e.jpg"
              alt="Professional electrician at work"
              className="w-full h-[520px] lg:h-[640px] object-cover object-top"
            />
            {/* Dark overlay at top */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/20 to-transparent pointer-events-none" />
          </div>

          {/* Floating stat card */}
          <div className="absolute -bottom-6 -right-6 lg:-right-10 bg-white/95 backdrop-blur-xl rounded-2xl px-6 py-5 shadow-[0_8px_40px_rgba(0,0,0,0.14)] border border-[#E8F0F8]">
            <div className="text-[#00D9FF] text-4xl font-black leading-none mb-1">20<span className="text-2xl">+</span></div>
            <div className="text-[#0A1628] text-[13px] font-semibold uppercase tracking-widest">Years of Excellence</div>
          </div>

          {/* Floating badge */}
          <div className="absolute -top-5 -left-5 lg:-left-8 bg-[#0A1628] rounded-xl px-5 py-3 shadow-[0_8px_32px_rgba(0,0,0,0.25)] border border-[#00D9FF]/20">
            <div className="flex items-center gap-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shield-star-fill text-[#00D9FF] text-base" />
              </span>
              <span className="text-white text-[12px] font-semibold tracking-wide whitespace-nowrap">Licensed & Insured</span>
            </div>
          </div>
        </div>

        {/* Right — Content */}
        <div className="w-full lg:w-[55%] scroll-reveal scroll-from-right">
          <span className="inline-block text-[#00D9FF] text-[11px] font-semibold uppercase tracking-[3px] mb-4">Why DOC Electric</span>
          <h2 className="text-4xl lg:text-5xl font-black text-[#0A1628] leading-tight mb-6">
            Built on Trust.<br />
            <span className="text-[#1A3A5C]">Delivered with Care.</span>
          </h2>
          <p className="text-[#4A6178] text-[17px] leading-relaxed mb-10 max-w-lg">
            We&apos;re not just electricians — we&apos;re neighbors, community members, and craftspeople who
            take pride in every job. Faith-based and employee-owned, our team treats your home like it&apos;s our own.
          </p>

          {/* Pillars */}
          <div className="flex flex-col gap-5">
            {pillars.map((p) => (
              <div key={p.title} className="flex items-start gap-4 group cursor-default">
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl bg-[#EDF4FB] group-hover:bg-[#00D9FF]/10 transition-colors duration-300">
                  <i className={`${p.icon} text-[#00D9FF] text-[18px]`} />
                </div>
                <div>
                  <div className="text-[15px] font-bold text-[#0A1628] mb-0.5">{p.title}</div>
                  <div className="text-[#5E7A96] text-[14px] leading-relaxed">{p.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <a
            href="#contact"
            className="inline-flex items-center gap-3 mt-10 px-7 py-3.5 bg-[#0A1628] hover:bg-[#0d1e35] text-white font-bold text-[13px] uppercase tracking-wider rounded-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(10,22,40,0.3)] cursor-pointer whitespace-nowrap"
          >
            Get a Free Estimate
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
